// TEMPORARY pricing hide (2026-08-17, sales request) — mirrors the TrackingMCP treatment and the
// same switch now in SchedulesMCP and LoadingMCP.
//
// Sales asked us to take PUBLIC price figures off the marketing surface while packaging is reworked
// across the family: a flat monthly figure reads as the whole cost even though lane volume, alerts
// and API/MCP usage drive the real number, so prospects self-disqualified before ever talking to us.
// Public price figures are replaced with a "Contact sales" ask.
//
// This is a REVERSIBLE switch: flip to `true` to restore every public price figure (the /pricing Pro
// tier, its FAQ answer and meta description, and the homepage dashboard's Go Pro chip).
//
// Scope is PUBLIC surfaces only — the signed-in /account upgrade button and the Stripe checkout it
// starts keep their figures, because a customer already inside needs to know what they pay.
export const SHOW_PUBLIC_PRICING = false
